import { Service } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from "@angular/material/core";
import moment from 'moment';

@Service()
export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      return moment(date).format('DD/MM/YYYY');
    }
    return moment(date).format('ddd, MMM D, YYYY');
  }

  parse(value: any): Date | null {
    if (typeof value === 'string' && value.length > 0) {
      const date = moment(value, 'DD/MM/YYYY', true);
      return date.isValid() ? date.toDate() : null;
    }
    return null;
  }
}

export const DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'numeric', year: 'numeric', day: 'numeric' }
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'numeric', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'numeric' },
  }
};
